<template>
  <div class='group-box' v-if="pink">
    <!-- 生成海报 -->
    <div class="poster" @click="createPoster"><span>生成专属海报</span></div>
    <Poster :show="showPosterPopup" :posterData="posterData" @close="showPosterPopup=false" />
  </div>
</template>
<script>
import { getPinkInfo } from './query.gql'
import Poster from '@/components/Poster'
export default {
  name: 'groupPoster',
  data() {
    return {
      pink: '', // 拼团信息
      posterData: null,
      wxShareLink: '',
      showPosterPopup: false
    }
  },
  components: {
    Poster
  },
  mounted() {
    this.loadInformations() // 获取拼团信息
  },
  methods: {
    loadInformations() {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      console.log('开始请求拼团数据')
      self.loadPinkInfo(self.$route.params.id).then(res => {
        console.log('拼团数据', res)
        self.pink = res.data.pink
        // 计算拼团成功还需人数
        self.pink.needNum = self.pink.peopleNum - self.pink.users.length
        self.wxShareLink = `${window.location.origin}/?#/group/${self.pink.id}/share`
        self.$toast.clear()
        self.$nextTick(() => {
          self.createPoster()
        })
      }).catch(err => {
        self.$toast.clear()
        console.error('page: group/poster。请求getPinkInfo报错', err)
      })
    },
    // 获取拼团信息
    loadPinkInfo(id) {
      return this.$apollo.query({
        query: getPinkInfo,
        variables: {
          id: parseInt(id)
        },
        fetchPolicy: 'no-cache'
      })
    },
    createPoster() {
      // 生成海报
      const self = this
      self.posterData = {
        user: self.pink.user,
        posterTplImg: self.pink.subject.posterTplImg,
        wxShareLink: self.wxShareLink
      }
      self.showPosterPopup = true
    }
  }
}
</script>
<style lang="scss" scoped>
.group-box {
  .poster {
    padding-bottom: 14px;
    text-align: center;
    span {
      border-bottom: 1px solid #ff623b;
      font-size: 12.5px;
      line-height: 17.5px;
      color: #ff623b;
    }
  }
}
</style>
